(function ga4CustomEvents() {
  // gtag must be present
  let gtagExists = typeof window.gtag != "undefined";
  if (!gtagExists) {
    setTimeout(ga4CustomEvents, 100);
    return false;
  }

  let gtag = window.gtag;

  A1_5min3page();
  A2_20_Percentages_Scroll();
  A3_6clicks();
  B1_Carousel_4_Images_View();
  B2_FAQ_or_Questions_Engaged();

  function getStoredValue(key, defaultValue = false) {
    return localStorage.getItem(key)
      ? parseInt(localStorage.getItem(key), 10)
      : defaultValue;
  }

  function setStoredValue(key, value) {
    localStorage.setItem(key, value);
  }

  function A1_5min3page() {
    const timeThreshold = 5 * 60; // 5 minutes in seconds
    const pageThreshold = 3;
    let eventName = "A1_5min3page";
    let eventTriggered = localStorage.getItem("A1_5min3page") === "true"; // Prevent multiple executions
    let startTime = Date.now();

    function getStoredValue(key, defaultValue = false) {
      return localStorage.getItem(key)
        ? parseInt(localStorage.getItem(key), 10)
        : defaultValue;
    }

    function setStoredValue(key, value) {
      localStorage.setItem(key, value);
    }

    // Retrieve existing values or initialize them
    let totalTimeOnSite = getStoredValue("totalTimeOnSite", 0);
    let pagesVisited = getStoredValue("pagesVisited", 1);
    console.warn("totalTimeOnSite: ", totalTimeOnSite);
    console.warn("pagesVisited: ", pagesVisited);

    function checkConditions() {
      //console.warn("eventTriggered: ", eventTriggered);
      //console.warn("totalTimeOnSite: ", totalTimeOnSite);
      //console.warn("pagesVisited: ", pagesVisited);
      if (
        !eventTriggered &&
        totalTimeOnSite >= timeThreshold &&
        pagesVisited >= pageThreshold
      ) {
        trackEvent();
        eventTriggered = true;
        setStoredValue(eventName, "true");
      }
    }

    function trackEvent() {
      console.warn("Function executed: User met both criteria.");

      // Send Event for A1_5min3page
      gtag("event", "A1_5min3page", {});
    }

    function updateTotalTime() {
      const currentTime = Date.now();
      totalTimeOnSite += Math.floor((currentTime - startTime) / 1000);
      startTime = currentTime;
      setStoredValue("totalTimeOnSite", totalTimeOnSite);
    }

    function trackPageViews() {
      updateTotalTime();
      pagesVisited++;
      setStoredValue("pagesVisited", pagesVisited);

      checkConditions();
    }

    // Track when the user leaves the page (for navigation or closing)
    window.addEventListener("beforeunload", trackPageViews);

    // Periodic check while the user stays on the same page
    setInterval(() => {
      if (getStoredValue("pagesVisited")) {
        updateTotalTime();
        checkConditions();
      }
    }, 1000);
  }

  function A2_20_Percentages_Scroll() {
    document.addEventListener("scroll", function checkScroll() {
      const scrollPosition = window.scrollY;
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollPosition / totalHeight) * 100;

      if (scrollPercentage >= 20) {
        trackEvent();
        document.removeEventListener("scroll", checkScroll); // Remove listener to prevent repeated execution
      }
    });

    function trackEvent() {
      console.log("User has scrolled past 20% of the page!");

      // Send Event for A2_20_Percentages_Scroll
      gtag("event", "A2_20_Percentages_Scroll", {
        path: location.pathname,
      });
    }
  }

  function A3_6clicks() {
    let totalClicksThreshold = 6;
    let eventName = "A3_6clicks";
    let eventTriggered = localStorage.getItem(eventName) === "true"; // Prevent Multiple Executions
    if (eventTriggered) return false;

    // Obtain Current Number of Clicks
    let totalNumberOfClicks = getStoredValue(
      "keyEventsCurrentNumberOfClicks",
      0
    );

    document.documentElement.addEventListener(
      `click`,
      function trackA3_6clicks(e) {
        totalNumberOfClicks++;
        setStoredValue("keyEventsCurrentNumberOfClicks", totalNumberOfClicks);

        if (totalNumberOfClicks >= totalClicksThreshold) {
          trackEvent();

          document.documentElement.removeEventListener(
            `click`,
            trackA3_6clicks
          );
        }
      }
    );

    function trackEvent() {
      gtag("event", "A3_6clicks");
    }
  }

  function B1_Carousel_4_Images_View() {
    const imageViewedThreshold = 3;
    let eventName = "B1_Carousel_4_Images_View";
    let eventTriggered =
      localStorage.getItem(eventName + location.pathname) === "true"; // Prevent Multiple Executions
    if (eventTriggered) return false;
    let totalNumberOfClicks = 0;

    let carouselImages = [...document.querySelectorAll(`.product__thumb-item`)];

    if (eventTriggered) return false;

    if (!carouselImages.length) {
      setTimeout(B1_Carousel_4_Images_View, 100);
      return false;
    }

    let itemsWithEvents = [];
    carouselImages.forEach((item) => {
      itemsWithEvents.push(item);
      item.addEventListener(`click`, trackB1_Carousel_4_Images_ViewClicks);
    });
    function trackB1_Carousel_4_Images_ViewClicks(e) {
      if (e.target.querySelector(`.is-active`)) {
        return false;
      }

      totalNumberOfClicks++;

      if (totalNumberOfClicks >= imageViewedThreshold) {
        trackEvent();
        setStoredValue(eventName + location.pathname, "true");
        console.warn(`about to do it`);
        itemsWithEvents.forEach((cImage) => {
          console.warn(`cImage: `, cImage);
          cImage.removeEventListener(
            `click`,
            trackB1_Carousel_4_Images_ViewClicks
          );
        });
      }
    }

    function trackEvent() {
      gtag("event", "B1_Carousel_4_Images_View", { page: location.href });
    }
  }

  function B2_FAQ_or_Questions_Engaged() {
    let eventName = "B2_FAQ_or_Questions_Engaged";
    let eventTriggered =
      localStorage.getItem(eventName + location.pathname) === "true"; // Prevent Multiple Executions
    let faqAccordionItems = [
      ...document.querySelectorAll(`.accordion-title.jas-accordion-title`),
    ];

    if (eventTriggered) return false;

    if (!faqAccordionItems.length) {
      setTimeout(B2_FAQ_or_Questions_Engaged, 100);
      return false;
    }

    faqAccordionItems.forEach((item) => {
      item.addEventListener(
        `click`,
        function trackB2_FAQ_or_Questions_EngagedClick(e) {
          trackEvent();
          item.removeEventListener(
            `click`,
            trackB2_FAQ_or_Questions_EngagedClick
          );
          setStoredValue(eventName + location.pathname, "true");
        }
      );
    });

    function trackEvent() {
      gtag("event", "B2_FAQ_or_Questions_Engaged", { page: location.href });
    }
  }
})();
